import { Utils } from '@portal/api'

export default {
  methods: {
    $_file_getPicturePath(pictureFileName) {
      return pictureFileName ? Utils.getUserAvatarPath(pictureFileName) : '/avatar.png'
    },
    $_file_getNewsPath(imageName) {
      return Utils.getNewsImgPath(imageName)
    },
    $_file_getDocumentPath(id) {
      return Utils.getDocumentFilePath(id)
    }
  }
}